import React from 'react';
import LHRTab from './LHRTab';
import { FileSpreadsheet } from 'lucide-react';
import { Box, Paper, Typography, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled components for custom styling
const GradientBackground = styled(Box)({
  minHeight: '100vh',
  background: 'linear-gradient(to bottom right, #f8fafc, #eff6ff, #eef2ff)',
});

const Header = styled(Paper)({
  backgroundColor: 'white',
  borderBottom: '1px solid #e2e8f0',
  boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  borderRadius: 0,
});

const IconWrapper = styled(Box)({
  padding: '10px',
  background: 'linear-gradient(to bottom right, #6366f1, #9333ea)',
  borderRadius: '8px',
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const Dashboard = () => {
  return (
    <GradientBackground>
      {/* Header */}
      <Header elevation={0}>
        <Container maxWidth={false} sx={{ maxWidth: '1600px', mx: 'auto', px: { xs: 3, sm: 4, md: 6 }, py: 5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <IconWrapper>
              <FileSpreadsheet style={{ width: '28px', height: '28px', color: 'white' }} />
            </IconWrapper>
            <Box>
              <Typography 
                variant="h4" 
                component="h1" 
                sx={{ 
                  fontWeight: 'bold', 
                  color: '#1e293b',
                  letterSpacing: '-0.025em',
                  fontSize: { xs: '1.5rem', sm: '1.875rem', md: '2.25rem' }
                }}
              >
                Decorpot Sales Dashboard
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#64748b',
                  mt: 0.5,
                  fontSize: '0.875rem'
                }}
              >
                Lead Health Analytics
              </Typography>
            </Box>
          </Box>
        </Container>
      </Header>

      {/* Main Content */}
      <Container 
        maxWidth={false} 
        sx={{ 
          maxWidth: '1600px', 
          mx: 'auto', 
          px: { xs: 3, sm: 4, md: 6 }, 
          py: 6 
        }}
        data-testid="lhr-tab-content"
      >
        <LHRTab />
      </Container>
    </GradientBackground>
  );
};

export default Dashboard;